const countriesRICG = [
/*   {
    countryCode: "AG",
    value: "1268",
    label: "Antigua & Barbuda (+1268)",
    name: "Antigua & Barbuda",
    disabled: true
  }, */
  {
    countryCode: "AR",
    value: "54",
    label: "Argentina (+54)",
    name: "Argentina",
    disabled: true
  },
/*   {
    countryCode: "BS",
    value: "1242",
    label: "Bahamas (+1242)",
    name: "Bahamas",
    disabled: true
  }, */
/*   {
    countryCode: "BB",
    value: "1246",
    label: "Barbados (+1246)",
    name: "Barbados",
    disabled: true
  }, */
/*   {
    countryCode: "BZ",
    value: "501",
    label: "Belice (+501)",
    name: "Belice",
    disabled: true
  }, */
  {
    countryCode: "BO",
    value: "591",
    label: "Bolivia (+591)",
    name: "Bolivia",
    disabled: true
  },
  {
    countryCode: "BR",
    value: "55",
    label: "Brasil (+55)",
    name: "Brasil",
    disabled: true
  },
/*   {
    countryCode: "CA",
    value: "1",
    label: "Canada (+1)",
    name: "Canada",
    disabled: true
  }, */
  {
    countryCode: "CL",
    value: "56",
    label: "Chile (+56)",
    name: "Chile",
    disabled: true
  },
  {
    countryCode: "CO",
    value: "57",
    label: "Colombia (+57)",
    name: "Colombia",
    disabled: true
  },
/*   {
    countryCode: "CR",
    value: "506",
    label: "Costa Rica (+506)",
    name: "Costa Rica",
    disabled: true
  }, */
/*   {
    countryCode: "DM",
    value: "1809",
    label: "Dominica (+1809)",
    name: "Dominica",
    disabled: true
  }, */
  {
    countryCode: "EC",
    value: "593",
    label: "Ecuador (+593)",
    name: "Ecuador",
    disabled: true
  },
 /*  {
    countryCode: "SV",
    value: "503",
    label: "El Salvador (+503)",
    name: "El Salvador",
    disabled: true
  }, */
/*   {
    countryCode: "GT",
    value: "502",
    label: "Guatemala (+502)",
    name: "Guatemala",
    disabled: true
  }, */
/*   {
    countryCode: "GD",
    value: "1473",
    label: "Grenada (+1473)",
    name: "Grenada",
    disabled: true
  }, */
/*   {
    countryCode: "GY",
    value: "592",
    label: "Guyana (+592)",
    name: "Guyana",
    disabled: true
  }, */
/*   {
    countryCode: "HT",
    value: "509",
    label: "Haiti (+509)",
    name: "Haiti",
    disabled: true
  }, */
/*   {
    countryCode: "HN",
    value: "504",
    label: "Honduras (+504)",
    name: "Honduras",
    disabled: true
  }, */
/*   {
    countryCode: "JM",
    value: "1876",
    label: "Jamaica (+1876)",
    name: "Jamaica",
    disabled: true
  }, */
/*   {
    countryCode: "MX",
    value: "52",
    label: "Mexico (+52)",
    name: "Mexico",
    disabled: true
  }, */
/*   {
    countryCode: "NI",
    value: "505",
    label: "Nicaragua (+505)",
    name: "Nicaragua",
    disabled: true
  }, */
/*   {
    countryCode: "PA",
    value: "507",
    label: "Panama (+507)",
    name: "Panama",
    disabled: true
  }, */
  {
    countryCode: "PY",
    value: "595",
    label: "Paraguay (+595)",
    name: "Paraguay",
    disabled: true
  },
  {
    countryCode: "PE",
    value: "51",
    label: "Peru (+51)",
    name: "Peru",
    disabled: true
  },
/*   {
    countryCode: "DO",
    value: "1809",
    label: "Republica Dominicana (+1809)",
    name: "Republica Dominicana",
    disabled: true
  }, */
 /*  {
    countryCode: "KN",
    value: "1869",
    label: "St. Kitts (+1869)",
    name: "St. Kitts",
    disabled: true
  }, */
/*   {
    countryCode: "SC",
    value: "1758",
    label: "St. Lucia (+1758)",
    name: "St. Lucia",
    disabled: true
  }, */
/*   {
    countryCode: "SR",
    value: "597",
    label: "Suriname (+597)",
    name: "Suriname",
    disabled: true
  }, */
/*   {
    countryCode: "TT",
    value: "1868",
    label: "Trinidad & Tobago (+1868)",
    name: "Trinidad & Tobago",
    disabled: true
  }, */
  {
    countryCode: "UY",
    value: "598",
    label: "Uruguay (+598)",
    name: "Uruguay",
    disabled: true
  }
];

export default countriesRICG;
